import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse } from '@/types'

export const html2pdf = async (
  html: string,
  type: string,
  resumeId: Number
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(
      `/html2pdf/download`,
      { html: html, type: type , resume_id: resumeId},
      { responseType: 'blob' }
    )
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
